import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AvailableGuideData,
  GuideItem,
  GuideKeys,
  SelectedGuideIndex,
} from './guide';
import { GuideService } from './guide.service';

@Component({
  selector: 'app-guide-modal',
  templateUrl: './guide-modal.component.html',
  styleUrls: ['./guide-modal.component.scss'],
  standalone: false,
})
export class GuideModalComponent implements OnInit {
  @Output() dismissed = new EventEmitter<void>();

  availableGuides$: Observable<AvailableGuideData>;
  selectedGuide$: Observable<SelectedGuideIndex>;

  showMenu = false;

  constructor(private guideService: GuideService) {}

  ngOnInit() {
    this.availableGuides$ = this.guideService.getAvailableGuides$();
    this.selectedGuide$ = this.guideService.getSelectedGuideIndex$();
  }

  getMenuItems(guideData: AvailableGuideData) {
    return Object.values(guideData);
  }

  getSelectedGuideText(guide: GuideItem, selectedIndex: number | null) {
    return selectedIndex !== null
      ? guide.subTexts[selectedIndex].html
      : guide?.html;
  }

  onDismiss() {
    this.dismissed.emit();
  }

  setMenuVisible() {
    this.showMenu = true;
  }

  setActiveText(key: GuideKeys, subTextId: number | null) {
    this.guideService.setSelectedGuide(key, subTextId);
  }

  onMenuItemClick(selection: SelectedGuideIndex) {
    this.setActiveText(selection.key, selection.selectedSubMenuIndex);
    this.showMenu = false;
  }

  onNextTextClick() {
    this.guideService.showNextSubGuide();
  }

  get showNext() {
    return this.guideService.selectionHasSubGuide();
  }
}
